import React, { ReactElement } from 'react';
import { get, isEmpty } from 'lodash';
import moment from 'moment-timezone';
import { injectIntl, IntlShape } from 'react-intl';
import { Vehicule } from 'containers/PreOpeningPage/typings';
import { VEHICULE } from 'containers/data-structure';
import * as featureService from 'features/fflip-helpers';
import { FEATURES } from 'features/features';
import { translate } from 'containers/services/translate';
import messages from 'containers/common/LegalProceedings/JudgementAdd/Forms/JudgementAddPrononcings/messages';
import { getVehicleFromSagisInfo } from 'containers/PreOpeningPage/OpposingParty/utils';

export interface ExpertiseVehiculeProps {
  intl: IntlShape;
  vehicule: Vehicule;
  children?: ReactElement | ReactElement[];
  displayExpertise?: boolean;
  sagisOpposingParties: any;
  isBasicManagement?: boolean;
}

const ExpertiseVehicule: React.FC<ExpertiseVehiculeProps> = (
  props,
): JSX.Element => {
  const { vehicule } = props;

  return (
    <section className="item-container">
      <article className="item">
        {featureService.hasFeature(FEATURES.MIGRATION_CLAIM_INFO) &&
        !props.isBasicManagement &&
        !isEmpty(
          getVehicleFromSagisInfo(
            get(vehicule, 'partKey'),
            props.sagisOpposingParties,
          ),
        )
          ? get(
              getVehicleFromSagisInfo(
                get(vehicule, 'partKey'),
                props.sagisOpposingParties,
              ),
              'registrationNumber',
            )
          : vehicule[VEHICULE.REGISTRATION_NUMBER]}
      </article>
      {props.displayExpertise && (
        <>
          {!isEmpty(get(vehicule, ['expertise', 'expertName'])) && (
            <article className="field-expert">
              <div className="label">
                {translate(messages.nameExpertField, props)}
              </div>
              <div className="value">
                {get(vehicule, ['expertise', 'expertName'])}
              </div>
            </article>
          )}
          {!isEmpty(get(vehicule, ['expertise', 'address'])) && (
            <article className="field-expert">
              <div className="label">
                {translate(messages.adresseExpertField, props)}
              </div>
              <div className="value">
                {get(vehicule, ['expertise', 'address'])}
              </div>
            </article>
          )}
          {!isEmpty(get(vehicule, ['expertise', 'expertiseDate'])) && (
            <article className="field-expert">
              <div className="label">
                {translate(messages.dateExpertiseField, props)}
              </div>
              <div className="value">
                {moment(get(vehicule, ['expertise', 'expertiseDate'])).format(
                  'DD/MM/YYYY',
                )}
              </div>
            </article>
          )}
        </>
      )}
      <article className="item-form">{props.children}</article>
    </section>
  );
};

ExpertiseVehicule.defaultProps = {
  displayExpertise: false,
};

export default injectIntl(ExpertiseVehicule);
